
import { Card, CardContent, CardHeader, CardTitle, CardDescription, CardFooter } from "@/components/ui/card";
import { PaymentCreationForm } from "@/components/payments/PaymentCreationForm";
import { usePaymentCreation } from "@/hooks/usePaymentCreation";

const PaymentCreation = () => {
  const { createPayment, isSubmitting } = usePaymentCreation();

  return (
    <div className="container mx-auto py-6">
      <h1 className="text-3xl font-bold mb-6">Creación de Cobro</h1>
      
      <Card>
        <CardHeader>
          <CardTitle>Nuevo Cobro</CardTitle>
          <CardDescription>
            Seleccione la casa, el mes y los gastos a incluir en el cobro
          </CardDescription>
        </CardHeader>
        
        <CardContent>
          <PaymentCreationForm 
            onSubmit={createPayment}
            isSubmitting={isSubmitting}
          />
        </CardContent>
      </Card>
    </div>
  );
};

export default PaymentCreation;
